export const woundFilterType = {
  None: 0,
  Evaluation: 1,
  Assessment: 2,
  Both: 3
}
